import { render, staticRenderFns } from "./board_detail_location.vue?vue&type=template&id=8231e8d0&scoped=true"
import script from "./board_detail_location.vue?vue&type=script&lang=js"
export * from "./board_detail_location.vue?vue&type=script&lang=js"
import style0 from "./board_detail_location.vue?vue&type=style&index=0&id=8231e8d0&prod&lang=scss&scoped=true"
import style1 from "./board_detail_location.vue?vue&type=style&index=1&id=8231e8d0&prod&lang=scss"
import style2 from "./board_detail_location.vue?vue&type=style&index=2&id=8231e8d0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8231e8d0",
  null
  
)

export default component.exports